/* eslint-disable */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, TTitle } from '../../components/Widget';
import { Collapse } from 'antd';
import { useUpdateComponentState } from '../../../hooks';
import icon1 from '@/assets/cybersecurity2026/topic1000/visit/icon1.png';
import icon2 from '@/assets/cybersecurity2026/topic1000/visit/icon2.png';
import icon3 from '@/assets/cybersecurity2026/topic1000/visit/icon3.png';
import panelData1 from '@/assets/cybersecurity2026/topic1000/visit/img.png';
import panelData2 from '@/assets/cybersecurity2026/topic1000/visit/img_1.png';
import panelData3 from '@/assets/cybersecurity2026/topic1000/visit/img_2.png';
import panelData4 from '@/assets/cybersecurity2026/topic1000/visit/img_3.png';
import panelData5 from '@/assets/cybersecurity2026/topic1000/visit/img_4.png';
import panelData6 from '@/assets/cybersecurity2026/topic1000/visit/img_5.png';
import panelData7 from '@/assets/cybersecurity2026/topic1000/visit/img_6.png';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

import ArrowImg from '../../../../../../assets/cybersecurity2026/finger.gif';
import ToolsBox from '../../components/ToolsBox';
import ToolsTop from '../../../../../../assets/cybersecurity2026/topic1000/tools-bj-top.png';
import ToolsBottom from '../../../../../../assets/cybersecurity2026/topic1000/tools-bj-bottom.png';
import Quiz from '../../components/Quiz';

const { Panel } = Collapse;

interface ISection3Props {
  settings: any;
}

const iconList = [icon1, icon2, icon3];

const picMap: any = {
  1: panelData1,
  2: panelData2,
  3: panelData3,
  4: panelData4,
  5: panelData5,
  6: panelData6,
  7: panelData7,
};
// step步骤显示
const StepsDisplay: React.FC<{ steps: any[]; onComplete: any; id: any }> = ({
  steps,
  onComplete,
  id,
}) => {
  const [visibleSteps, setVisibleSteps] = React.useState(1); // 默认只显示第一步
  const timeoutRefs = React.useRef<NodeJS.Timeout[]>([]);
  const isMountedRef = React.useRef(true);

  // 清理所有定时器
  React.useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      timeoutRefs.current.forEach((timeout) => {
        if (timeout) {
          clearTimeout(timeout);
        }
      });
      timeoutRefs.current = [];
    };
  }, []);

  // 点击第一步时触发后续步骤的逐步展示
  const handleFirstStepClick = () => {
    if (visibleSteps === 1 && steps.length > 1) {
      let step = 2;
      const showNextStep = () => {
        if (!isMountedRef.current) return; // 组件已卸载，不再更新状态
        if (step <= steps.length) {
          setVisibleSteps(step);
          step++;
          if (step <= steps.length) {
            const timeout = setTimeout(showNextStep, 500); // 每500ms展示下一步
            timeoutRefs.current.push(timeout);
          }
        }
      };
      showNextStep();
      onComplete();
    }
  };

  return (
    <div
      className="cybersecurity-processing-content"
      id={id}
    >
      {visibleSteps === 1 && (
        <div className="cybersecurity-processing-arrow">
          <img src={ArrowImg} alt="" />
        </div>
      )}
      {steps?.map((s: any, index: number) => (
        <div
          key={s.id}
          className={`step step-${s.id} ${
            index < visibleSteps ? 'visible' : 'hidden'
          }`}
          onClick={index === 0 ? handleFirstStepClick : undefined} // 只有第一步可以点击触发动画
          style={{
            cursor: index === 0 && visibleSteps === 1 ? 'pointer' : 'default',
            opacity: index < visibleSteps ? 1 : 0,
            transform:
              index < visibleSteps ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 2s ease-in-out',
            transitionDelay: index * 0.5 + 's',
          }}
        >
          {/*<div className="step-title">{s.title}</div>*/}
          <div className="step-desc">{s.desc}</div>
        </div>
      ))}
    </div>
  );
};
const Section4: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const ID = '5';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[4],
    [settings?.paragraphs]
  );
  const [state, setState] = React.useState({
    useChecked: [] as any,
    useActive: 0 as any,
    deepfakeFlag: false,
    deepfakeFlag2: false,
    quiz: false,
  });
  const [checked, setChecked] = React.useState<any>([]);
  const [activeArr, setActiveArr] = React.useState([0, 1, 2,3]);
  const [activeList, setActiveList] = React.useState([0, 1, 2]);
  const [active, setActive] = React.useState<any>(0);

  const getArrayMin = (arr: any, value: any,setArr:any  ) => {
    const newArr = arr.filter((item: any) => item !== value);
    setArr([...newArr]);
    if (!Array.isArray(newArr) || newArr.length === 0) return null;
    return Math.min(...newArr);
  };
  const tapUse = (i: any) => {
    if (!state.useChecked.includes(i)) {
      const min = getArrayMin(activeArr, i,setActiveArr);
      setState({
        ...state,
        useChecked: [...state.useChecked, i],
        useActive: min,
      });
    }
  };
  useEffect(() => {
    if(state.useChecked.length>=4){
      updateComponentState(p_course, p_topic, ID,'cybersecurity2026-topic1000-section4-1')
    }
  }, [state.useChecked]);
  const changeTab = (key: any) => {
    if (!checked.includes(key)) {
      const newChecked = [...checked, key].filter(Boolean);
      setChecked(newChecked);
      if (newChecked.length >= 3) {
        updateComponentState(
          p_course,
          p_topic,
          ID,
          'cybersecurity2026-topic1000-section4-4'
        );
      }
      const min = getArrayMin(activeList, Number(key),setActiveList);
      setActive(min);
    }
  };
  const handleComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'cybersecurity2026-topic1000-section4-2'
    );
  }, [updateComponentState, p_course, p_topic, ID]);
  const quiz = paragraphsSettings?.quiz;
  const stepsComplete = () =>{
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'cybersecurity2026-topic1000-section4-3'
    );
  }
  return (
    <div className="topic-section-4">
      <CTitle title={paragraphsSettings.title} />
      <div className="section4-item1">
        <div className="section4-item1-content">
          <div className="content-left">{paragraphsSettings?.l1}</div>
          <div className="content-right">{paragraphsSettings?.l2}</div>
        </div>
      </div>
      <div className="use" id="cybersecurity2026-topic1000-section4-1">
        <TTitle title={paragraphsSettings?.tips1} />
        <div className="use-action">
          {paragraphsSettings?.tipsList.map((item: any, i: number) => (
            <div
              className={`use-box ${
                state.useChecked.includes(i) ? 'clicked' : ''
              }`}
              key={i}
            >
              <div className="use-item" onClick={() => tapUse(i)}>
                <div className={`use-item-front front-${i + 1}`}>
                  <div
                    className="use-item-title"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                  <div className="use-item-content">{item.content}</div>
                </div>
                <div className={`use-item-back back-${i + 1}`}>
                  <div
                    className="use-item-title"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                </div>
                {state.useActive === i && (
                  <img src={ArrowImg} alt="" className="img-point" />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <ToolsBox
        leftText={paragraphsSettings?.l3}
        rightText={paragraphsSettings?.l4}
        leftBackgroundImage={ToolsTop}
        rightBackgroundImage={ToolsBottom}
        id="cybersecurity2026-topic1000-section4-2"
        onComplete={handleComplete}
      />
      <TTitle title={paragraphsSettings?.stepsTitle} />
      {/* 網絡安全事件的應變和處理 */}
      <StepsDisplay
        id={'cybersecurity2026-topic1000-section4-3'}
        steps={paragraphsSettings?.l4steps}
        onComplete={stepsComplete}
      />
      <TTitle title={paragraphsSettings?.panelDataTitle} />
      <div className="visit" id="cybersecurity2026-topic1000-section4-4">
        <Collapse
          expandIcon={({ isActive }) =>
            isActive ? (
              <MinusOutlined
                style={{ color: '#FFFFFF', fontSize: '1.75rem' }}
              />
            ) : (
              <PlusOutlined style={{ color: '#FFFFFF', fontSize: '1.75rem' }} />
            )
          }
          accordion
          onChange={(key) => changeTab(key)}
        >
          {paragraphsSettings?.panelData?.map((item: any, index: number) => (
            <Panel
              header={
                <>
                  {active === index && (
                    <img className="arrow-img" src={ArrowImg} alt="" />
                  )}
                  {item.header}
                  <img src={iconList[index]} alt="" />
                </>
              }
              key={index}
            >
              {item?.list?.map((subItem: any, subIndex: number) => (
                <div className="topic-section-3-img-con" key={subIndex}>
                  <div className="left">
                    <p>{subItem.title}</p>
                  </div>
                  <div className="right">
                    <img
                      className={`img-${subItem.img}`}
                      src={picMap[subItem.img]}
                      alt=""
                    />
                  </div>
                </div>
              ))}
            </Panel>
          ))}
        </Collapse>
      </div>
      <div
        id="cybersecurity2026-topic1000-section4-question"
        className="topic-quiz"
      >
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'cybersecurity2026-topic1000-section4-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section4;
